import { ConfigProvider } from "antd";
import { Navigate, Route, Routes as Switch } from "react-router-dom";
import SSO from "../pages/SSO";
import { Login } from "../pages/Login";
import { Darfs } from "../pages/Darfs";
import { Reports } from "../pages/Reports";
import Cadastro from "../pages/Cadastro";
import { Clients } from "../pages/Clients";
import PrivateRoute from "./PrivateRoutes";
import OnlyPublicRoute from "./OnlyPublicRoute";
import OnlyClientAccountPermissionRoute from "./OnlyClientAccountPermissionRoute";
import { MinhaConta } from "../pages/MinhaConta";
import PageNotFound from "../pages/PageNotFound";
import { Regulation } from "../pages/Regulation";
import PageWrapper from "../components/PageWrapper";
import { Professionals } from "../pages/Professionals";
import { Authorization } from "../pages/Authorization";
import { ForgotPassword } from "../pages/ForgotPassword";
import { ChangePassword } from "../pages/ChangePassword";
import { PublicWrapper } from "../components/PublicWrapper";
import { AuthorizeAccountant } from "../pages/AuthorizeAccountant";

function Routes() {
  ConfigProvider.config({
    theme: {
      primaryColor: "#FBC105",
      infoColor: "#181818",
      errorColor: "#DD2244",
      successColor: "#00BC75",
    },
  });
  return (
    <>
      <Switch>

        <Route
          path="ca"
          element={
            <PublicWrapper>
              <OnlyClientAccountPermissionRoute />
            </PublicWrapper>
          }
        >
          <Route path="auth/:token" element={<Authorization />} />
        </Route>

        <Route
          path="p"
          element={
            <PublicWrapper>
              <OnlyPublicRoute />
            </PublicWrapper>
          }
        >
          <Route path="login" element={<Login />} />
          <Route path="cadastrar" element={<Cadastro />} />
          <Route path="forgot-password" element={<ForgotPassword />} />
          <Route path="change-password/:token" element={<ChangePassword />} />
          <Route path="sso/:token" element={<SSO />} />
          <Route
            path="authorize-accountant/:token"
            element={<AuthorizeAccountant />}
          />
          <Route path="" element={<Navigate to="cadastrar" />} />
          <Route path="*" element={<Navigate to="cadastrar" />} />
        </Route>

        <Route
          path="/"
          element={
            <PageWrapper sideBar={true} header={true} overflow={true}>
              <PrivateRoute />
            </PageWrapper>
          }
        >
          <Route path="/darf" element={<Darfs />} />
          <Route path="/report" element={<Reports />} />
          <Route path="/clients" element={<Clients />} />
          <Route path="/conta" element={<MinhaConta />} />
          <Route path="/regulacao" element={<Regulation />} />
          <Route path="/professionals" element={<Professionals />} />
          <Route path="" element={<Navigate to="/clients" />} />
          <Route path="*" element={<Navigate to="/clients" />} />
        </Route>

        <Route path="" element={<PageNotFound />} />
        <Route path="*" element={<PageNotFound />} />
      </Switch>
    </>
  );
}

export default Routes;
